import {
  getDatabase,
  ref,
  onValue,
  push,
  set,
  remove,
} from "firebase/database";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./firebase.utils";
import { User } from "../types/User";
import { HonkMovie } from "../types/Movie";

const getDbRef = (extension: string = "") => {
  const firebaseApp = initializeApp(firebaseConfig);
  const db = getDatabase(firebaseApp);
  const MOVIE_REF = ref(db, "movies/" + extension);
  return MOVIE_REF;
};

export const getMovies = (
  updateFunc: (data: HonkMovie[]) => void
): HonkMovie[] => {
  const MOVIE_REF = getDbRef();
  onValue(MOVIE_REF, (snapshot) => {
    const data = snapshot.val();
    updateFunc(data);
  });
  return [];
};

export const uploadRecommendation = (movie: HonkMovie) => {
  const MOVIE_REF = getDbRef();
  push(MOVIE_REF, {
    ...movie,
  });
};

export const likeMovie = (movie: HonkMovie, user: User) => {
  const MOVIE_REF = getDbRef(movie.honk_id);
  let newLikes;
  if (movie.likedBy == null) {
    newLikes = [user.uid];
  } else {
    if (movie.likedBy.includes(user.uid)) {
      newLikes = [...movie.likedBy];
      newLikes.splice(
        movie.likedBy.findIndex((uid) => uid === user.uid),
        1
      );
    } else {
      newLikes = movie.likedBy.concat([user.uid]);
    }
  }

  set(MOVIE_REF, {
    ...movie,
    likedBy: newLikes,
  });
};

export const markMovieAsWatched = (movie: HonkMovie) => {
  const MOVIE_REF = getDbRef(movie.honk_id);
  set(MOVIE_REF, { ...movie, watched: !movie.watched });
};

export const deleteRecommendation = (movie: HonkMovie) => {
  const MOVIE_REF = getDbRef(movie.honk_id);
  remove(MOVIE_REF);
};
